import React from 'react';
import { MapPin, Clock, MessageSquare, Car } from 'lucide-react';
import { STUDIO, MAP_EMBED, MAP_LINK } from './midtownData';

const facts = [
  { icon: MapPin, label: 'Studio', value: `${STUDIO.street}, ${STUDIO.city}, ${STUDIO.region} ${STUDIO.zip}`, id: 'address' },
  { icon: Clock, label: 'Hours', value: STUDIO.hours, id: 'hours' },
  { icon: MessageSquare, label: 'Text', value: STUDIO.phoneDisplay, href: `sms:${STUDIO.phoneE164}`, id: 'phone' },
  { icon: Car, label: 'Parking', value: 'Street parking on I Street & nearby blocks, plus paid lots close by', id: 'parking' },
];

const MidtownGettingHere = () => (
  <section className="bg-gray-900 text-white py-20" data-testid="midtown-getting-here">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-stretch">
      <div>
        <p className="text-xs tracking-[0.25em] uppercase text-teal-300">Getting here</p>
        <h2 className="mt-3 text-3xl md:text-4xl font-serif">Right in the middle of Midtown.</h2>
        <p className="mt-4 text-white/75 leading-relaxed max-w-lg">
          The studio sits a few blocks from Sutter's Fort and Sutter Medical Center. Midtown is easy to walk and bike, so lots of my clients come on foot from nearby or drive in from Downtown and East Sac.
        </p>
        <dl className="mt-10 grid sm:grid-cols-2 gap-4">
          {facts.map(({ icon: Icon, label, value, href, id }) => (
            <div key={id} className="bg-white/5 border border-white/10 rounded-2xl p-5 hover:bg-white/10 transition-colors duration-300" data-testid={`midtown-fact-${id}`}>
              <dt className="flex items-center gap-2 text-xs uppercase tracking-widest text-teal-300"><Icon className="w-4 h-4" />{label}</dt>
              <dd className="mt-2 text-sm text-white/90">{href ? <a href={href} className="underline underline-offset-4">{value}</a> : value}</dd>
            </div>
          ))}
        </dl>
      </div>
      <div className="relative rounded-[2rem] overflow-hidden min-h-[22rem] border border-white/10">
        <iframe title="Map of Ayumi Suzuki Massage Therapy, 2528 I Street, Midtown Sacramento" src={MAP_EMBED} className="absolute inset-0 w-full h-full" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="midtown-map-embed" />
        <a href={MAP_LINK} target="_blank" rel="noopener noreferrer" className="absolute top-4 right-4 bg-white text-gray-900 text-sm px-4 py-2 rounded-full shadow-lg hover:bg-teal-50 transition-colors duration-300" data-testid="midtown-open-maps-link">
          Open in Google Maps
        </a>
      </div>
    </div>
  </section>
);

export default MidtownGettingHere;
